
import { auth} from "@/scripts/firebase";
//import { NoticeProps } from "@/scripts/datatypes"
//import { ValidationObserver } from 'vee-validate'

import { Component,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common';
import PhoneAuth from "@/components/PhoneAuth.vue"

@Component({
  components: {
    PhoneAuth
  }
})

export default class SignInPhone extends Mixins(Common) {
  async created(){
    console.trace('created');
    auth.signOut();
  }

  async mounted(){
    console.trace('mounted');
  }


  destroyed() {
    console.trace('destroyed');
  }
}
